import * as actions from "./actions/queries";
import update from "immutability-helper";

export const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: {},
};

const nonAmlRoles = [
  "Dev",
  "StaffManager",
  "CompanyManager",
  "FundManager",
  "TermsManager",
  "SalesRepManager",
];

const claimRoleTypes = ["AmlReader", "AmlAdmin", ...nonAmlRoles];

const claims = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_USER_CLAIMS_REQUEST:
      return update(state, {
        fetching: { $set: true },
      });
    case actions.GET_USER_CLAIMS_SUCCESS: {
      let data = {};

      action.response.forEach((item) => {
        if (claimRoleTypes.indexOf(item.Type) >= 0)
          data[item.Type] = item.Value;
      });

      return update(state, {
        fetching: { $set: false },
        fetched: { $set: true },
        data: { $set: data },
      });
    }
    case actions.GET_USER_CLAIMS_ERROR: {
      // Fallback for any error in BE we assume user can at least have access to anything but AML
      let data = {};
      nonAmlRoles.forEach((item) => {
        data[item] = "true";
      });

      return update(state, {
        fetching: { $set: false },
        fetched: { $set: true },
        error: { $set: action.error },
        data: { $set: data },
      });
    }
    default:
      return state;
  }
};

export default claims;
